export default "__VITE_ASSET__BZOMvOb6__"